import { Controller } from "@hotwired/stimulus";
import Tabulator from "../lib/tabulator";

const RARITY_VALUES = {
  "": "All",
  C: "Common",
  U: "Uncommon",
  R: "Rare",
  M: "Mythic",
  S: "Special",
};

export default class extends Controller {
  connect() {
    const tableEl = this.element.querySelector("table");
    if (!tableEl) return;

    const rows = Array.from(tableEl.querySelectorAll("tbody tr")).map((row) => {
      const obj = {};
      Array.from(row.querySelectorAll("td")).forEach((td, i) => {
        obj[`c${i}`] = td.innerHTML;
      });
      return obj;
    });

    const columns = Array.from(tableEl.querySelectorAll("thead th")).map((th, i) => {
      const col = {
        title: th.textContent.trim(),
        field: `c${i}`,
        formatter: "html",
        hozAlign: th.classList.contains("text-end") ? "right" : "left",
        headerHozAlign: th.classList.contains("text-end") ? "right" : "left",
        headerFilter: "input",
      };

      if (i === 0) {
        col.widthGrow = 3;
      }

      if (i === 2) {
        col.headerFilter = "list";
        col.headerFilterParams = { values: RARITY_VALUES, clearable: true };
        col.headerFilterFunc = (headerValue, rowValue) => {
          if (!headerValue) return true;
          return rowValue.trim().startsWith(headerValue);
        };
      }

      return col;
    });

    this.tabulator = new Tabulator(tableEl, {
      data: rows,
      columns: columns,
      layout: "fitColumns",
      selectable: false,
    });

    this.tabulator.on("tableBuilt", () => this.buildColumnMenu(columns));
  }

  buildColumnMenu(columns) {
    const menu = this.element.querySelector(".column-selector-menu");
    if (!menu) return;

    menu.innerHTML = "";
    columns.forEach((col, i) => {
      if (i === 0) return;
      const li = document.createElement("li");
      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.className = "form-check-input me-2";
      checkbox.checked = true;
      checkbox.addEventListener("change", (e) => {
        if (e.target.checked) {
          this.tabulator.showColumn(col.field);
        } else {
          this.tabulator.hideColumn(col.field);
        }
      });

      const label = document.createElement("label");
      label.className = "dropdown-item";
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(col.title));
      li.appendChild(label);
      menu.appendChild(li);
    });
  }

  disconnect() {
    this.tabulator?.destroy();
  }
}
